<template>
  <v-layout row>
    <v-flex>
      <v-card>
        <progress-bar :show="busy"></progress-bar>
        <v-card-title primary-title class="grey lighten-4">
          <h3 class="headline mb-0">{{ $t('personal_info') }}</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-form @submit.prevent="update" @keydown="form.onKeydown($event)" ref="form" v-model="valid" lazy-validation>
            <v-container fluid grid-list-lg pa-3>
              <v-layout row wrap>
                <v-flex xs12 md5>
                  <h3 class="subheading mb-2">{{ $t('info_name_address') }}</h3>
                  <v-container fluid grid-list-lg pa-0>
                    <v-layout row wrap v-if="form.is_company=='1'">

                      <v-flex xs12 md6>
                        <!-- Company name -->
                        <text-input
                          :form="form"
                          :label="$t('name_company')"
                          :v-errors="errors"
                          :value.sync="form.company_name"
                          name="company_name"
                          v-validate="'required'"
                        ></text-input>
                      </v-flex>

                      <v-flex xs12 md6>
                        <!-- Last Name -->
                        <text-input
                          :form="form"
                          :label="$t('company_org_no')"
                          :v-errors="errors"
                          :value.sync="form.company_org_no"
                          name="company_org_no"
                          v-validate="''"
                          solo
                        ></text-input>
                      </v-flex>

                    </v-layout>

                    <v-layout row wrap v-else>
                      <v-flex xs12 md6>
                        <!-- First Name -->
                        <text-input
                          :form="form"
                          :label="$t('name_first')"
                          :v-errors="errors"
                          :value.sync="form.name_first"
                          name="name_first"
                          v-validate="'required'"
                        ></text-input>
                      </v-flex>

                      <v-flex xs12 md6>
                        <!-- Last Name -->
                        <text-input
                          :form="form"
                          :label="$t('name_last')"
                          :v-errors="errors"
                          :value.sync="form.name_last"
                          name="name_last"
                          v-validate="'required'"
                          solo
                        ></text-input>
                      </v-flex>

                    </v-layout>
                  </v-container>

                  <v-container fluid grid-list-lg pa-0 pb-3 v-if="form.is_company!='1'">
                    <v-layout row wrap>

                      <!-- Birth year -->
                      <v-flex xs4 md4>
                        <v-select
                          :class="{ danger: errors.has('form.birth_year') }"
                          :items="years"
                          :label="$t('birth_year')"
                          v-model="form.birth_year"
                          name="birth_year"
                          :rules="[(v) => !!v || 'The Birth year field is required.']"
                          required
                          box
                        ></v-select>
                      </v-flex>

                      <!--
                      <v-flex xs4 md4>
                        <v-select
                          :class="{ danger: errors.has('form.birth_month') }"
                          :items="months"
                          :label="$t('birth_month')"
                          v-model="form.birth_month"
                          name="birth_month"
                          :rules="[(v) => !!v || 'The Birth month field is required.']"
                          required
                          box
                        ></v-select>
                      </v-flex>
                      -->
                      <!-- 
                      <v-flex xs4 md4>
                        <v-select
                          :class="{ danger: errors.has('form.birth_day') }"
                          :items="days"
                          :label="$t('birth_day')"
                          v-model="form.birth_day"
                          name="birth_day"
                          :rules="[(v) => !!v || 'The Birth day field is required.']"
                          required
                          box
                        ></v-select>
                      </v-flex>
                      -->

                    </v-layout>
                  </v-container>

                  <!-- Email -->
                  <email-input
                    :form="form"
                    :label="$t('email')"
                    :v-errors="errors"
                    :value.sync="form.email"
                    name="email"
                    v-validate="'required|email'"
                    box
                  ></email-input>

                  <!-- Phone -->
                  <text-input
                    :form="form"
                    :label="$t('phone')"
                    :v-errors="errors"
                    :value.sync="form.phone"
                    name="phone"
                    v-validate="'required'"
                  ></text-input>

                  <!-- Address street 1 -->
                  <text-input
                    :form="form"
                    :label="$t('address_street_1')"
                    :v-errors="errors"
                    :value.sync="form.address_street_1"
                    name="address_street_1"
                    v-validate="''"
                  ></text-input>

                  <!-- Address street 2 -->
                  <text-input
                    :form="form"
                    :label="$t('address_street_2')"
                    :v-errors="errors"
                    :value.sync="form.address_street_2"
                    name="address_street_2"
                    v-validate="''"
                  ></text-input>

                  <!-- Address zip -->
                  <text-input
                    :form="form"
                    :label="$t('address_zip')"
                    :v-errors="errors"
                    :value.sync="form.address_zip"
                    name="address_zip"
                    v-validate="''"
                  ></text-input>

                  <!-- Address city -->
                  <text-input
                    :form="form"
                    :label="$t('address_city')"
                    :v-errors="errors"
                    :value.sync="form.address_city"
                    name="address_city"
                    v-validate="''"
                  ></text-input>

                  <!-- Address country -->
                  <v-autocomplete
                    :class="'pb-2'"
                    :items="countries"
                    item-text="country_name"
                    item-value="iso"
                    box
                    label="Country"
                    placeholder="Start typing to Search"
                    autocomplete="no"
                    browser-autocomplete
                    v-model="form.address_country"
                    name="address_country"
                    :rules="[(v) => !!v || 'The Country field is required']"
                    required
                  ></v-autocomplete>

                  <v-container fluid grid-list-lg pa-0>
                    <v-layout row wrap>

                      <v-flex xs12 md6 pt-0>
                        <!-- Fitness -->
                        <v-select
                          :items="invoice_currencies"
                          :label="$t('invoice_currency')"
                          v-model="form.invoice_currency"
                          box
                        ></v-select>
                      </v-flex>

                      <v-flex xs12 md6 pt-0>
                      </v-flex>         

                    </v-layout>
                  </v-container>

                </v-flex>

                <v-flex xs12 md7>
                  <div v-if="form.is_company!='1'">
                  <div style="margin-bottom: 8px;">
                    <h3 style="float:left;" class="subheading mb-2">{{ $t('info_skills') }}</h3>
                    <div style="float:right;">
                      <v-dialog
                        v-model="skills_dialog"
                        width="600"
                      >
                        <v-btn
                          slot="activator"
                          color="primary"
                          flat
                          small
                          class="ma-0"
                        >
                          <i class="material-icons" style="margin-right:10px;">help_outline</i>
                          Skills
                        </v-btn>

                        <v-card>
                          <v-card-title
                            class="headline grey lighten-2"
                            primary-title
                          >
                            Skills levels
                          </v-card-title>

                          <v-card-text>
                            <h3>Fitness</h3>
                            <table class="table">
                              <tbody>
                                <tr>
                                  <th>1</th>
                                  <td>I don’t exercise regularly and ski for less than two weeks a year. I can walk (on skis with skins) for an hour without any difficulties.</td>
                                </tr>
                                <tr>
                                  <th>2</th>
                                  <td>I exercise once or twice a week and ski for two to four weeks a year. I can walk (on skis with skins) for two hours without any difficulties.</td>
                                </tr>
                                <tr>
                                  <th>3</th>
                                  <td>I exercise regularly and ski at least one month a year. I can walk (on skis with skins) for half a day without any difficulties.</td>
                                </tr>
                                <tr>
                                  <th>4</th>
                                  <td>I exercise frequently and go skiing as often as I can. I can walk uphill and/or ski down for a whole day.</td>
                                </tr>
                              </tbody>
                            </table>
                            <h3>Technical</h3>
                            <table class="table">
                              <tbody>
                                <tr>
                                  <th>A</th>
                                  <td>I can ski red pistes. I have little off-piste experience but dream of powder skiing… Discovering ski touring and going uphill on skis with skins is something I would like to try out.</td>
                                </tr>
                                <tr>
                                  <th>B</th>
                                  <td>I can ski all types of pistes. I sometimes ski off-piste but would like to improve my skills. Ski touring interests me.</td>
                                </tr>
                                <tr>
                                  <th>C</th>
                                  <td>I can ski all types of piste including off-piste as long as the terrain isn’t too steep. I have already gone ski touring and would like to refine my technique, knowledge of the mountains and about the equipment that is required.</td>
                                </tr>
                                <tr>
                                  <th>D</th>
                                  <td> I am a very competent skier and can easily ski anywhere, whether on-piste or off-piste. I go ski touring regularly.</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-card-text>

                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary"
                              flat
                              @click="skills_dialog = false"
                            >
                              Close
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                    <div style="clear:both;"></div>
                  </div>
                  <v-container fluid grid-list-lg pa-0>
                    <v-layout row wrap>

                      <v-flex xs12 md6 pt-0>
                        <!-- Fitness -->
                        <v-select
                          :class="{ danger: errors.has('form.level_fitness') }"
                          :items="skills_fitness"
                          :label="$t('skills_fitness')"
                          v-model="form.level_fitness"
                          name="level_fitness"
                          :rules="[(v) => !!v || 'Fitness level is required']"
                          required
                          box
                        ></v-select>
                      </v-flex>

                      <v-flex xs12 md6 pt-0>
                        <!-- Technical -->
                        <v-select
                          :class="{ danger: errors.has('form.skills_technical') }"
                          :items="skills_technical"
                          :label="$t('skills_technical')"
                          v-model="form.level_technical"
                          name="skills_technical"
                          :rules="[(v) => !!v || 'Technical skills is required']"
                          required
                          box
                        ></v-select>
                      </v-flex>         

                    </v-layout>
                  </v-container>

                  <v-textarea
                    box
                    name="skills_comment"
                    :label="$t('skills_comment')"
                    v-model="form.skills_comment"
                  ></v-textarea>


                  <h3 class="subheading mb-2">{{ $t('info_physical') }}</h3>
                  <v-container fluid grid-list-lg text-xs-center pa-0>
                    <v-layout row wrap>

                      <v-flex xs12 md4>
                        <!-- Shoe size -->
                        <v-select
                          :items="shoe_size"
                          :label="$t('shoe_size')"
                          v-model="form.shoe_size"
                          box
                        ></v-select>
                      </v-flex>

                      <v-flex xs12 md4>
                        <!-- Weight -->
                        <text-input
                          :form="form"
                          :label="$t('weight')"
                          :v-errors="errors"
                          :value.sync="form.weight"
                          name="weight"
                          v-validate="'numeric'"
                        ></text-input>
                      </v-flex>

                      <v-flex xs12 md4>
                        <!-- height -->
                        <text-input
                          :form="form"
                          :label="$t('height')"
                          :v-errors="errors"
                          :value.sync="form.height"
                          name="height"
                          v-validate="'numeric'"
                        ></text-input>
                      </v-flex>    

                    </v-layout>
                  </v-container>

                  <v-textarea
                    box
                    name="food_medical_comment"
                    :label="$t('food_medical_comment')"
                    v-model="form.food_medical_comment"
                  ></v-textarea>

                  <h3 class="subheading mb-2">{{ $t('info_insurance') }}</h3>
                  <v-container fluid grid-list-lg text-xs-center pa-0>
                    <v-layout row wrap>

                      <v-flex xs12 md6>
                        <!-- Insurance company -->
                        <text-input
                          :form="form"
                          :label="$t('insurance_company')"
                          :v-errors="errors"
                          :value.sync="form.insurance_company"
                          name="insurance company"
                          v-validate="'required'"
                        ></text-input>
                      </v-flex>

                      <v-flex xs12 md6>
                        <!-- Insurance number -->
                        <text-input
                          :form="form"
                          :label="$t('insurance_number')"
                          :v-errors="errors"
                          :value.sync="form.insurance_number"
                          name="insurance number"
                          v-validate="'required'"
                        ></text-input>
                      </v-flex>         

                    </v-layout>
                  </v-container>

                  <h3 class="subheading mb-2">{{ $t('emergency_contact') }}</h3>
                  <v-container fluid grid-list-lg pa-0>
                    <v-layout row wrap>

                      <v-flex xs12 md6>
                        <!-- ICE First Name -->
                        <text-input
                          :form="form"
                          :label="$t('name_first')"
                          :v-errors="errors"
                          :value.sync="form.ice_name_first"
                          name="ice_name_first"
                          v-validate="'required'"
                        ></text-input>
                      </v-flex>

                      <v-flex xs12 md6>
                        <!-- ICE Last Name -->
                        <text-input
                          :form="form"
                          :label="$t('name_last')"
                          :v-errors="errors"
                          :value.sync="form.ice_name_last"
                          name="ice_name_last"
                          v-validate="'required'"
                          solo
                        ></text-input>
                      </v-flex>

                    </v-layout>
                  </v-container>

                  <!-- ICE Email 
                  <email-input
                    :form="form"
                    :label="$t('email')"
                    :v-errors="errors"
                    :value.sync="form.ice_email"
                    name="ice_email"
                    v-validate="'email|required'"
                    box
                  ></email-input>
                  -->

                  <!-- ICE Phone -->
                  <text-input
                    :form="form"
                    :label="$t('phone')"
                    :v-errors="errors"
                    :value.sync="form.ice_phone"
                    name="ice_phone"
                    v-validate="'required'"
                  ></text-input>

                </div>
                </v-flex>
              </v-layout>
            </v-container>


          <v-card-actions>
            <submit-button :flat="false" :color="'primary'" :form="form" :label="$t('save')"></submit-button>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Form from 'vform'
import { mapGetters } from 'vuex'

export default {
  name: 'profile-view',
  data: () => ({
    valid: true,
    busy: false,
    form: new Form({
      name_first: '',
      name_last: '',
      is_company: 0,
      company_name: '',
      company_org_no: '',
      birth_year: '',
      // birth_month: '',
      // birth_day: '',
      address_street_1: '',
      address_street_1: '',
      email: '',
      phone: '',
      address_street_1: '',
      address_street_2: '',
      address_zip: '',
      address_city: '',
      address_country: '',
      insurance_company: '',
      insurance_number: '',
      ice_name_first: '',
      ice_name_last: '',
      ice_phone: '',
      ice_email: '',
      level_fitness: '',
      level_technical: '',
      skills_comment: '',
      food_medical_comment: '',
      shoe_size: '',
      weight: '',
      height: '',
      company_name: '',
      invoice_currency: '',
    }),
    skills_dialog: false
  }),

  computed: {
    skills_fitness: function () {
      return ['1','2','3','4']
    },
    skills_technical: function () {
      return ['A','B','C','D']
    },
    shoe_size: function () {
      var sizes = [];
      for(var i = 34; i <= 50; i++) { 
        sizes.push(String(i))
      }
      return sizes;
    },
    years: function () {
      var sizes = [];
      for(var i = 2019; i >= 1920; i--) { 
        sizes.push(String(i))
      }
      return sizes;
    },
    months: function () {
      var sizes = [];
      for(var i = 1; i <= 12; i++) { 
        sizes.push(String((i < 10 ? '0' : '') + i))
      }
      return sizes;
    },
    days: function () {
      var sizes = [];
      for(var i = 1; i <= 31; i++) { 
        sizes.push(String((i < 10 ? '0' : '') + i))
      }
      return sizes;
    },
    invoice_currencies: function () {
      return ['SEK','EUR','USD',]
    },
    ...mapGetters({
      user: 'authUser',
      countries: 'countries'
    })
  },

  created () {
    // Fill the form with user data.
    this.form.keys().forEach(key => {
      this.form[key] = this.user[key]
    })
  },

  methods: {
    async update () {
      if (await this.formHasErrors()){
        this.$refs.form.validate()
        return
      } else if(!this.$refs.form.validate()) {
        return
      }

      
      this.$emit('busy', true)

      const { data } = await this.form.post(process.env.API_URL+'/user')

      if(data.client_id){
        await this.$store.dispatch('updateUser', { user: data })

        this.$emit('busy', false)

        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('info_updated')
        })
      } else {
        var msg = ''
        if(data.error) msg = data.error
        this.$emit('busy', false)
        this.$store.dispatch('responseMessage', {
          type: 'error',
          text: this.$t('info_update_failed') + ' ' + msg
        })
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// profile.vue?80ea2d58